import { render, staticRenderFns } from "./SecondQuestion.vue?vue&type=template&id=56be8c18&"
import script from "./SecondQuestion.vue?vue&type=script&lang=js&"
export * from "./SecondQuestion.vue?vue&type=script&lang=js&"
import style0 from "./SecondQuestion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports